import { CUSTOM_FIELDS_TYPES } from 'features/custom-fields/custom-fields.constants';
import { Injectable } from '@angular/core';
import { HttpService } from 'services/http/http.service';
import { CustomFields } from '../../custom-fields.interface';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ShowIfHttpError } from '@certemy/common';
import { CUSTOM_FIELD_TYPES } from 'constants/constants';

@Injectable()
export class TemplateCustomFieldsService {
  constructor(private http: HttpService) {}

  @ShowIfHttpError('Cannot receive organizational custom fields.')
  getCustomFields(): Observable<CustomFields.Item[]> {
    return this.http.get('/custom_field');
  }

  createOrUpdateCustomField(
    field: CustomFields.Field,
    forSelectedOrganization: number,
  ): Observable<CustomFields.Item[]> {
    const url = forSelectedOrganization ? `/organization/${forSelectedOrganization}/custom_field` : '/custom_field';
    if (field.type_id === CUSTOM_FIELD_TYPES.PHONE_NUMBER) {
      field.default_value = field.default_value ? field.default_value.replace(/\D+/g, '') : '';
    } else if ([CUSTOM_FIELD_TYPES.STRING, CUSTOM_FIELD_TYPES.TEXTAREA].includes(field.type_id)) {
      field.default_value = field.default_value ? field.default_value.trim() : field.default_value;
    }
    return field.field_id ? this.http.put(`${url}/${field.field_id}`, field) : this.http.post(url, field);
  }

  @ShowIfHttpError('An error occurred while deleting field.')
  deleteCustomField(field: CustomFields.Field): Observable<CustomFields.Item[]> {
    return this.http.delete(`/custom_field/${field.field_id}`);
  }

  createOrUpdateCustomGroup(group: CustomFields.Group): Observable<CustomFields.Item[]> {
    return group.group_id
      ? this.http
          .put(`/custom_field_group/${group.group_id}`, group)
          .pipe(this.http.showIfHttpError('An error occurred while updating group.'))
      : this.http
          .post('/custom_field_group', group)
          .pipe(this.http.showIfHttpError('An error occurred while creating group.'));
  }

  @ShowIfHttpError('An error occurred while deleting group.')
  deleteCustGroup(groupId: number): Observable<CustomFields.Item[]> {
    return this.http.delete(`/custom_field_group/${groupId}`);
  }

  @ShowIfHttpError('An error occurred while reordering.')
  reorderCustom(schema: CustomFields.ReorderSchema): Observable<CustomFields.Item[]> {
    return this.http.put('/custom_field/reorder', schema);
  }

  @ShowIfHttpError('Cannot receive custom fields secure terms.')
  getCustomSecureWords(): Observable<string[]> {
    return this.http.get('/custom-field-instance/secure-words').pipe(map(data => data.secureWords));
  }
}
